import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBookSimple: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="book-simple, guide, info, faq"><path fillRule="evenodd" clipRule="evenodd" d="M6.75 2C5.23122 2 4 3.23122 4 4.75V19.25C4 20.7688 5.23122 22 6.75 22H16.25C18.3211 22 20 20.3211 20 18.25V5.75C20 3.67893 18.3211 2 16.25 2H6.75ZM5.5 19V19.25C5.5 19.9404 6.05964 20.5 6.75 20.5H16.25C17.4926 20.5 18.5 19.4926 18.5 18.25V16.7503C17.8733 17.221 17.0942 17.5 16.25 17.5H7C6.17157 17.5 5.5 18.1716 5.5 19Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBookSimple;
